import { fetchUnifiedPlatformAPI, UnifiedPlatformEndpoints } from '../../../extras';

const getClaimAttachment = async (orderId: string, fileName: string): Promise<Blob> => {
  const safeDealOrderEndpoit: UnifiedPlatformEndpoints = UnifiedPlatformEndpoints.safeDealOrder;
  const safeDealClaimAttachmentEndpoint = `${safeDealOrderEndpoit}/${orderId}/attachment/${fileName}`;

  const fileType = fileName?.split('.')[1];
  const type = fileType ? `image/${fileType}` : 'application/json';

  return fetchUnifiedPlatformAPI({
    endpoint: safeDealClaimAttachmentEndpoint,
    contentType: type,
  })
    .then(res => {
      if (res.status !== 200) {
        throw new Error('Unexpected response');
      }
      return res.blob();
    })
    .then(imgBlob => imgBlob);
};

export default getClaimAttachment;
